import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,

  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_ERROR,

  REGISTER_CONFIRM_REQUEST,
  REGISTER_CONFIRM_SUCCESS,
  REGISTER_CONFIRM_ERROR,

  RECOVER_REQUEST,
  RECOVER_SUCCESS,
  RECOVER_ERROR,
} from "../actions/auth";
import { USER_REQUEST } from "../actions/user";
import HTTP from "@/utils/http.js";

const state = {
  token: localStorage.getItem("user-token") || "",
  auth_status: "",
  authHasLoadedOnce: false,
  register_status: "",
  confirm_status: "",
  recover_status: "",
};

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.auth_status
};

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      HTTP({ url: "login", data: user, method: "POST" })
        .then(resp => {
          localStorage.setItem("user-token", resp.data.token);
          HTTP.defaults.headers.common['Authorization'] = `Bearer: ${resp.data.token}`
          commit(AUTH_SUCCESS, resp.data);
          dispatch(USER_REQUEST);
          resolve(resp);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem("user-token");
          HTTP.defaults.headers.common['Authorization'] = '';
          reject(err);
        });
    });
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem("user-token");
      HTTP.defaults.headers.common['Authorization'] = '';
      resolve();
    });
  },

  [REGISTER_REQUEST]: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit(REGISTER_REQUEST);
      HTTP({ url: "register", data: user, method: "POST" })
        .then(resp => {
          commit(REGISTER_SUCCESS);
          resolve(resp);
        })
        .catch(err => {
          commit(REGISTER_ERROR, err);
          localStorage.removeItem("user-token");
          HTTP.defaults.headers.common['Authorization'] = '';
          reject(err);
        });
    });
  },

  [REGISTER_CONFIRM_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(REGISTER_CONFIRM_REQUEST);
      HTTP({ url: "register/confirm", data: req, method: "POST" })
        .then(resp => {
          localStorage.setItem("user-token", resp.data.token);
          HTTP.defaults.headers.common['Authorization'] = `Bearer: ${resp.data.token}`
          commit(REGISTER_CONFIRM_SUCCESS, resp.data);
          dispatch(USER_REQUEST);
          resolve(resp);
        })
        .catch(err => {
          commit(REGISTER_CONFIRM_ERROR, err);
          localStorage.removeItem("user-token");
          HTTP.defaults.headers.common['Authorization'] = '';
          reject(err);
        });
    });
  },

  [RECOVER_REQUEST]: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      commit(RECOVER_REQUEST);
      HTTP({ url: "recover", data: data, method: "POST" })
        .then(resp => {
          commit(RECOVER_SUCCESS);
          resolve(resp);
        })
        .catch(err => {
          commit(RECOVER_ERROR, err);
          localStorage.removeItem("user-token");
          HTTP.defaults.headers.common['Authorization'] = '';
          reject(err);
        });
    });
  },
};

const mutations = {
  [AUTH_REQUEST]: state => {
    state.auth_status = "loading";
  },
  [AUTH_SUCCESS]: (state, data) => {
    state.auth_status = "success";
    state.token = data.token;
    state.authHasLoadedOnce = true;
  },
  [AUTH_ERROR]: state => {
    state.auth_status = "error";
    state.authHasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: state => {
    state.token = "";
    state.auth_status = "";
    state.authHasLoadedOnce = false;
    state.register_status = "";
    state.confirm_status = "";
    localStorage.removeItem("user-token");
  },

  [REGISTER_REQUEST]: state => {
    state.register_status = "loading";
  },
  [REGISTER_SUCCESS]: (state) => {
    state.register_status = "success";
  },
  [REGISTER_ERROR]: state => {
    state.register_status = "error";
  },

  [REGISTER_CONFIRM_REQUEST]: state => {
    state.confirm_status = "loading";
  },
  [REGISTER_CONFIRM_SUCCESS]: (state, data) => {
    state.confirm_status = "success";
    state.auth_status = "success";
    state.token = data.token;
    state.authHasLoadedOnce = true;
  },
  [REGISTER_CONFIRM_ERROR]: state => {
    state.confirm_status = "error";
  },

  [RECOVER_REQUEST]: state => {
    state.recover_status = "loading";
  },
  [RECOVER_SUCCESS]: (state) => {
    state.recover_status = "success";
  },
  [RECOVER_ERROR]: state => {
    state.recover_status = "error";
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};